export class ApiError extends Error {
  public statusCode: number;

  constructor({ message, statusCode }: { message: string; statusCode: number }) {
    super(message);

    this.statusCode = statusCode;
  }
}
